const objFunc = () => {
  return {
    stores: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
